// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__M6qNU","productName":"Table_productName__3d-QN"};